import React from "react";
import { ArrowRight, Calendar, Gift } from "@phosphor-icons/react";

export const STRATEGY_MEETING_URL = "https://calendly.com/intentbrain/ranktrust-io";

export default function BlueprintMeetingCTA() {
  return (
    <section
      className="bento p-6 lg:p-8"
      style={{ background: "#0B0F14", color: "white", border: "1px solid #2D5BFF33" }}
      data-testid="blueprint-meeting-cta"
    >
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_220px] gap-7 lg:gap-9 items-center">
        <div>
          <div className="text-[11px] font-mono tracking-[0.25em] uppercase" style={{ color: "#7FA6FF" }}>
            Your Next Step
          </div>
          <h2 className="font-display text-3xl lg:text-4xl font-black tracking-tight mt-2 leading-tight">
            Walk Through What We Found
          </h2>
          <p className="text-white/75 mt-3 max-w-2xl leading-relaxed">
            During a 15-minute RankTrust Strategy Meeting, we&apos;ll review your assessment, identify which opportunity deserves attention first, and show you what to focus on next.
          </p>
          <div className="mt-5 rounded-lg border border-white/10 bg-white/5 p-4 max-w-2xl flex items-start gap-3">
            <Gift size={22} weight="fill" className="shrink-0 mt-0.5" style={{ color: "#D4AF37" }} />
            <div>
              <div className="font-bold text-white">Complimentary Playbook Included</div>
              <p className="text-sm text-white/65 mt-1 leading-relaxed">
                Schedule your meeting and receive a complimentary copy of <em>The Service Business Opportunity Playbook</em>. <strong>What you discover could change the decisions you make—and the future of your business.</strong>
              </p>
            </div>
          </div>
          <a
            href={STRATEGY_MEETING_URL}
            target="_blank"
            rel="noreferrer"
            className="mt-6 inline-flex items-center gap-2 px-6 py-3.5 rounded-lg font-bold text-sm hover:opacity-90 transition"
            style={{ background: "#2D5BFF", color: "white" }}
            data-testid="book-blueprint-strategy-meeting"
          >
            <Calendar size={16} weight="bold" />
            Get My Playbook & Review My Opportunities
            <ArrowRight size={15} weight="bold" />
          </a>
          <p className="text-xs text-white/45 mt-4 max-w-2xl leading-relaxed">
            Your assessment is the starting point. The meeting is where we connect the verified findings with your operating context and determine what deserves attention first.
          </p>
        </div>
        <div className="flex justify-center lg:justify-end" data-testid="playbook-cover-offer">
          <div className="relative w-[170px] sm:w-[190px] lg:w-[210px]">
            <div className="absolute -inset-3 rounded-2xl bg-[#2D5BFF]/10 blur-2xl" aria-hidden="true" />
            <img
              src="/service-business-opportunity-playbook-cover.jpg"
              alt="The Service Business Opportunity Playbook cover"
              className="relative w-full h-auto rounded-md shadow-2xl border border-white/10"
              loading="lazy"
            />
            <div className="relative mt-3 text-center text-[10px] font-mono uppercase tracking-[0.2em] text-[#D4AF37]">
              Complimentary With Meeting
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
